
import { XYZ } from "ol/source";


function osm() {
	return new XYZ({
		attributions: 'Tuiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer" target="_blank">ArcGIS</a>',
		url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
		crossOrigin: "Anonymous"
	})
	}

export default osm;